import React from 'react';
import { FieldError, useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import TopFieldContent from '../../../../Components/Form/components/TopFieldContent';
import ErrorMessage from '../../../../Components/Form/components/ErrorMessage';
import NCZIProductSearchSelect from './NCZIProductSearchSelect';

export interface NCZIProductSelectError {
	value?: FieldError;
}

interface Props {
	label?: string;
	name: string;
	isRequired?: boolean;
	className?: string;
	portal?: boolean;
}

const NCZIProductSearchSelectField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
	portal,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	const productError = error as NCZIProductSelectError;

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<NCZIProductSearchSelect
				{...field}
				error={productError?.value}
				portal={portal}
			/>
			{productError?.value?.message && (
				<ErrorMessage tx={productError?.value?.message} />
			)}
		</div>
	);
};

export default NCZIProductSearchSelectField;
